import React, { useEffect, useState } from 'react';
import { MdEventBusy } from 'react-icons/md';
import '../../styles/Events/eventDetail.css';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../settings';
import moment from 'moment';
import { displaySnackbar } from '../../utilities';

export default function JobPostDetail({ alumniData }) {
    const navigate = useNavigate();
    const [fetchedJobPost, setFetchedJobPost] = useState({});
    const [eventFound, setEventFound] = useState(false);
    let qualifications = [];
    if (fetchedJobPost?.qualifications) qualifications = JSON.parse(fetchedJobPost?.qualifications);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        let pathname = location.pathname.split('/');
        let id = pathname[pathname.length - 1];

        fetch(`${BASE_URL}/jobs/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (result) => {
                let response = await result.json();
                let the_job_post = response?.job_post;

                console.log('response:', response);

                console.log('the_job_post:', the_job_post);

                if (the_job_post) {
                    setEventFound(true);
                    setFetchedJobPost(the_job_post);
                } else {
                    setFetchedJobPost([]);
                }
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    displaySnackbar("Could't react the servers.");
                } else {
                    displaySnackbar("Couldn't fech job post");
                }
            });
    }, []);

    // handler to apply for job post
    const applyForJob = () => {
        if (fetchedJobPost?.email) {
        }
    };

    return eventFound ? (
        <div className='infoboard-event-detail-container'>
            <button onClick={() => navigate(-1)} className='go-back-btn'>
                👈️ Go Back
            </button>

            <div className='header'>
                <h1>Job Post Detail</h1>
            </div>

            <div className='details-content-item'>
                <span className='title'>Actions</span>
                {/* <button style={{ backgroundColor: 'orangered' }}>
                                Delete this profile
                            </button> */}
                <button className='apply-btn'>
                    <a
                        href={`mailto:${fetchedJobPost?.email}?from=${
                            alumniData ? alumniData?.email : 'abc@example.com'
                        }`}
                        style={{ color: '#eee', textDecoration: 'none' }}
                    >
                        Apply
                    </a>
                </button>
            </div>

            <div className='details-content-item'>
                <span className='title'>Details</span>
                {fetchedJobPost?.details?.length > 0 ? (
                    <p className='text about'>{fetchedJobPost?.details}</p>
                ) : (
                    <p className='empty-text'>...</p>
                )}
            </div>

            <div className='details-content-items'>
                <div className='details-content-item'>
                    <span className='title'>Company email</span>
                    {fetchedJobPost?.email?.length > 0 ? (
                        <p className='text'>{fetchedJobPost?.email}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Company name</span>
                    {fetchedJobPost?.companyName?.length > 0 ? (
                        <p className='text'>{fetchedJobPost?.companyName}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Position name</span>
                    {fetchedJobPost?.positionName?.length > 0 ? (
                        <p className='text'>{fetchedJobPost?.positionName}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Required Employees</span>
                    {fetchedJobPost?.count ? (
                        <p className='text'>{fetchedJobPost?.count}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Redirect url</span>
                    {fetchedJobPost?.redirectUrl?.length > 0 ? (
                        <p className='text'>{fetchedJobPost?.redirectUrl}</p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>

                <div className='details-content-item'>
                    <span className='title'>Offer closes on</span>
                    {fetchedJobPost?.dueDate?.length > 0 ? (
                        <p className='text'>
                            {moment(new Date(fetchedJobPost?.dueDate)).calendar()}
                        </p>
                    ) : (
                        <p className='empty-text'>...</p>
                    )}
                </div>
            </div>

            <div className='details-content-item'>
                <span className='title'>Qualifications</span>
                {fetchedJobPost?.qualifications?.length > 0 ? (
                    <ul className='qualifications-list'>
                        {qualifications.map((item, index) => (
                            <li key={`item?.uuid-#${index}`} className='qualifications-list-item'>
                                {item?.name || `item-#${index}`}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className='empty-text'>...</p>
                )}
            </div>
        </div>
    ) : (
        <div className='event-not-found-container'>
            <MdEventBusy size={100} color='#777' className='event-not-found-icon' />
            <span> job post not found </span>
        </div>
    );
}
